import { fetch } from '@atlassian/eoc-fetch';
import { URLBuilder } from '../../../common/utils/url-builder';
export const getUsersEndpoint = ({
  lastEvaluatedToken,
  limit,
  queryKey
}) => {
  const [_, query] = queryKey;
  let url = new URLBuilder(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
  return fetch(url);
};
export const getFilteredUsersEndpoint = ({
  lastEvaluatedToken,
  limit,
  queryKey
}) => {
  const [_, ...filters] = queryKey;
  if (filters.length === 0) {
    return Promise.resolve({
      lastEvaluatedToken: '',
      values: []
    });
  }
  return fetch('/v1/users/roles/filter', {
    method: 'POST',
    body: {
      limit,
      roles: filters,
      offset: lastEvaluatedToken || 0
    }
  });
};
export const getRolesEndpoint = () => {
  return fetch('/v1/users/roles');
};
export const updateRoleOfUserEndpoint = ({
  roleId,
  accountId
}) => {
  return fetch(`/v1/users/roles/assign`, {
    method: 'PATCH',
    body: {
      accountId,
      roleId
    }
  });
};